<template>
  <div class="contact-us container">
    <img class="wave-top" src="@/assets/img/wave_top_page.png" />
    <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />
    <h3>Contact Us</h3>
    <form class="contact-us-form" @submit.prevent="sendMessage">
      <div class="wrapper">
        <label>Email</label>
        <input
          type="email"
          name="email"
          v-model="email"
          required
          :readonly="sending"
        />
      </div>
      <div class="wrapper">
        <label>Name</label>
        <input
          type="text"
          name="name"
          v-model="name"
          required
          :readonly="sending"
        />
      </div>
      <div class="wrapper">
        <label>Message</label>
        <textarea
          name="message"
          v-model="message"
          v-autosize="message"
          style="resize:none"
          required
          :readonly="sending"
        ></textarea>
      </div>
      <div class="wrapper">
        <!-- <vue-recaptcha
          sitekey="6LedNLcZAAAAABJY9n3qDDrQPMTYyVoKwVbT4w1P"
          :loadRecaptchaScript="true"
        >
        </vue-recaptcha> -->
        <button class="button-cyan" :disabled="sending">
          <span class="loading" v-if="sending"
            ><span class="load open"></span> Sending</span
          >
          <span v-else>Submit</span>
        </button>
      </div>
    </form>

    <div class="circle-yellow circle1 animate-growing"></div>
    <div class="circle-yellow circle2 animate-shrinking"></div>
    <div class="circle-cyan animate-shrinking"></div>
    <div class="circle-orange animate-shrinking"></div>

    <img class="wave-bottom" src="@/assets/img/wave_bottom_page.png" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import VueRecaptcha from "vue-recaptcha";

export default {
  data() {
    return {
      email: "",
      name: "",
      message: ""
    };
  },

  // components: {
  //   VueRecaptcha
  // },

  computed: {
    ...mapGetters({
      sending: "contactUs/getSending",
      response: "contactUs/getResponse"
    })
  },

  watch: {
    $route() {
      this.clearForm();
    }
  },

  methods: {
    async sendMessage() {
      this.$store.commit("contactUs/TOGGLE_SENDING", true);
      const isEmailVerified = await this.$options.filters.verifyEmail(
        this.email
      );
      if (!isEmailVerified) {
        this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: "Email not valid!",
          button: "Close",
          hasError: true
        });

        this.$store.dispatch("alert/toggleAlert", true);

        this.$store.commit("contactUs/TOGGLE_SENDING", false);
        return;
      }

      var vue = this;
      let formData = new FormData();
      vue.isSending = true;

      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("message", this.message);

      await this.$store.dispatch("contactUs/send", {
        url: "/web/message/contact",
        data: formData
      });

      if (this.response.data) {
        if (this.response.data.status == 200) {
          this.$store.dispatch("alert/setContent", {
            title: "Thank You!",
            message:
              "We're glad to hear from you. We'll try to get back to you shortly.",
            button: "Done",
            hasError: false
          });

          this.message = "";
        } else if (this.response.data.status == 422) {
          this.$store.dispatch("alert/setContent", {
            title: "Sorry",
            message: this.response.data.errors.email[0],
            button: "Close",
            hasError: true
          });
        } else {
          this.$store.dispatch("alert/setContent", {
            title: "Sorry",
            message: "Something went wrong!",
            button: "Close",
            hasError: true
          });
        }
      } else {
        this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: "Something went wrong!",
          button: "Close",
          hasError: true
        });
      }

      this.$store.dispatch("alert/toggleAlert", true);
      this.isSending = false;
    },

    clearForm() {
      this.email = "";
      this.name = "";
      this.message = "";
      this.isSending = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-us {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 130px;
  margin-top: 160px;

  @include mobile {
    margin: 50px 0;
  }

  .wave-top {
    position: absolute;
    top: -245px;
    width: 100%;
    right: -325px;

    @include mobile {
      display: none;
    }
  }

  .wave-top-mobile {
    display: none;

    @include mobile {
      position: absolute;
      top: -150px;
      width: 115%;
      height: 100px;
      display: block;
    }
  }

  h3 {
    color: #4a4a4a;
    font-size: 18px;
    font-weight: bold;
    font-family: $Quicksand;
  }

  .wrapper {
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
    position: relative;
    padding-right: 50px;

    @include mobile {
      padding: 0;
      margin: 20px;
      flex-direction: column;
    }
  }

  .contact-us-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 100px 0;
    width: 100%;

    @include mobile {
      margin: 50px 0 0 0;
      padding: 20px;
    }

    .wrapper {
      label {
        color: $color2;
        font-size: 18px;
        text-align: right;
        margin-right: 20px;
        width: 80px;
        font-family: $Lato;

        @include mobile {
          text-align: left;
          margin-bottom: 10px;
        }
      }

      input,
      textarea {
        border: none;
        outline: none;
        background-color: #fff !important;
        border-bottom: 1px solid #979797;
        padding: 5px;
        width: 100%;
        max-width: 560px;
        color: #4a4a4a;
        font-size: 18px;
        font-family: $Lato;

        &:required {
          box-shadow: none !important;
        }
        &:invalid {
          box-shadow: none !important;
        }

        &:-webkit-autofill {
          background-color: #fff !important;
          box-shadow: 0 0 0px 1000px white inset !important;
        }
      }

      textarea {
        height: 38px;
        line-height: 25px;
        max-height: 150px;
        overflow-y: auto !important;
      }

      button {
        position: absolute;
        right: 155px;
        padding: 12px 22px;

        @include mobile {
          position: relative;
          right: 0;
          margin: 50px 0;
          width: 100px;
          align-self: center;
        }
      }
    }
  }

  .circle1 {
    position: absolute;
    height: 83px;
    width: 83px;
    top: -150px;
    left: 240px;

    @include mobile {
      height: 30px;
      width: 30px;
      top: -70px;
      left: 120px;
    }
  }

  .circle2 {
    position: absolute;
    height: 499px;
    width: 499px;
    bottom: -450px;
    right: -30px;

    @include mobile {
      height: 100px;
      width: 100px;
      bottom: 165px;
      right: unset;
      left: -75px;
    }
  }

  .circle-cyan {
    position: absolute;
    height: 376px;
    width: 376px;
    right: -235px;
    top: -90px;

    @include mobile {
      width: 100px;
      height: 100px;
      left: -50px;
      top: -25px;
    }
  }

  .circle-orange {
    position: absolute;
    height: 330px;
    width: 330px;
    left: -225px;
    top: 100px;

    @include mobile {
      width: 40px;
      height: 40px;
      top: 300px;
      left: unset;
      right: -15px;
    }
  }

  .wave-bottom {
    display: none;

    @include mobile {
      display: block;
      position: absolute;
      bottom: -60px;
      width: 800px;
      left: -160px;
      height: 110px;
    }
  }
}
</style>
